export default __webpack_public_path__ + "static/media/01.f54f1be5.webp";